exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".see-more.pagination{font-size:16px}.see-more.pagination>span{padding:5px 15px 5px 0;text-transform:none}.see-more.pagination>a{padding:5px 0 5px 15px;text-transform:none;border-left:1px solid #9e9e9e}@media only screen and (min-device-width:1000px) and (min-width:1000px){.see-more.pagination>span{width:98px;padding:15px 15px 15px 0;text-align:right}.see-more.pagination>a{padding:15px 0 15px 14px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./src/components/allMatchingJobs/allMatchingJobs.styl
// module id = 143
// module chunks = 0 1